import {Listbox, ListboxButton, ListboxOption, ListboxOptions} from "@headlessui/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import { v4 as uuidv4 } from 'uuid';
import {cn} from "../../lib/utils.ts";
import {fieldVariants} from "./fieldStyles.ts";

export interface Option {
    value: string | number
    label?: string
    tailwindColor?: string | null
}

export interface Properties {
    selected: Option
    options: Array<Option>
    onUpdateFunc: (value: string | number) => void
    customItemRenderFn?: (value: {value: string | number, isHighlighted?: boolean, isTrigger?: boolean}) => any
    disabled?: boolean
    rightAccessory?: React.ReactNode
    menuClassName?: string
    anchor?: "bottom" | "bottom start" | "bottom end"
    ariaLabel?: string
    ariaLabelledBy?: string
}

export default function Dropdown({selected, options, onUpdateFunc, customItemRenderFn, disabled = false, rightAccessory, menuClassName, anchor = "bottom start", ariaLabel, ariaLabelledBy}: Properties) {
    return (
        <Listbox disabled={disabled} value={selected.value} onChange={(e) => {
                onUpdateFunc(e)
            }}>
                <ListboxButton
                    aria-label={ariaLabel}
                    aria-labelledby={ariaLabelledBy}
                    className={cn(
                        fieldVariants(),
                        "relative flex items-center gap-2 pr-10 text-left",
                        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
                    )}>
                    {!!customItemRenderFn && <>
                        {customItemRenderFn({value: selected.value, isTrigger: true})}
                    </>}

                    {!customItemRenderFn && <>
                        {selected.tailwindColor &&
                            <div className={`bg-${selected.tailwindColor}-400 h-2 w-2 rounded-full`}></div>}
                        <span className="min-w-0 truncate whitespace-nowrap">{selected.label || selected.value}</span>
                    </>}
                    <span className="absolute inset-y-0 right-0 flex items-center gap-2 pr-2">
                        {rightAccessory}
                        <span className="pointer-events-none">
                            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400"/>
                        </span>
                    </span>
                </ListboxButton>
                <ListboxOptions anchor={anchor}
                                className={`${menuClassName ?? "w-[var(--button-width)]"} px-2 py-3 absolute z-10 mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm`}>
                    {!!options.length && options.map((option) => (
                        <ListboxOption key={uuidv4()} value={option.value} className={({focus}) =>

                            (focus ? 'bg-primary text-white ' : '') +
                            (!focus ? 'text-gray-900' : '') +
                            'relative cursor-pointer select-none py-2 pl-3 pr-9 flex items-center gap-2 hover:text-white rounded-md'

                        }>
                            {({focus}) => (
                                <>
                                    {!!customItemRenderFn && <>
                                        {customItemRenderFn({value: option.value, isHighlighted: focus})}
                                    </>}

                                    {!customItemRenderFn && <>
                                        {option.tailwindColor &&
                                            <div className={`bg-${option.tailwindColor}-400 h-2 w-2 rounded-full`}></div>}
                                        <span>{option.label || option.value}</span>
                                    </>}
                                </>
                            )}
                        </ListboxOption>
                    ))}
                    {!options.length && 'Geen opties beschikbaar'}
                </ListboxOptions>
            </Listbox>
    )
}


